import Layer from "./Layer";
import {fabric} from 'fabric';
import LayerManager from "./LayerManager";
import { SerializedShapeLayerInfo } from "./Interfaces";
import Fill from "./Fill";

export default class ShapesLayer extends Layer {
    shapeType:string
    fill!: Fill;
    rx: number
    ry:number
    borderStyle:'solid' | 'dashed'
    strokeDashArray:Array<number> | []
    strokeWidth: number
    stroke:string
    backgroundColor:string
    
    constructor(obj: fabric.Object, layerManager:LayerManager, name?: string){
        super(obj, layerManager, name);
        this.type = "shape";
        this.shapeType = "";
        this.fabricRef.backgroundColor = "rgba(0,0,0,0)"
    }

    public setFillColor(fillColor: string) {
        this.emit("BEFORE_MODIFY", this.toJSON());
        
        try {
          this.fabricRef.set({ fill: fillColor });
          this.fill = fillColor;
          this.fabricRef.canvas?.renderAll();
        } catch (e) {
          console.error(e);
        }
        
        this.fabricRef.canvas?.fire("object:modified", { target: this.fabricRef });
        this.emit("MODIFIED", this.toJSON());
    }      

    public setCornerRoundness(rx: number, ry?: number) {
        this.emit("BEFORE_MODIFY", this.toJSON());
        
        try {
          (this.fabricRef as fabric.Rect).set({ rx, ry });
          this.rx = rx;
          this.ry = ry;
          this.fabricRef.canvas?.renderAll();
        } catch (e) {
          console.error(e);
        }
        
        this.fabricRef.canvas?.fire("object:modified", { target: this.fabricRef });
        this.emit("MODIFIED", this.toJSON());
    }      

    public setBorderStyle(style: 'solid' | 'dashed' = 'solid', strokeDashArrayParam: Array<number>) {
        this.emit("BEFORE_MODIFY", this.toJSON());
        
        try {
          const strokeDashArray = style === 'dashed' ? strokeDashArrayParam : [];
          this.fabricRef.set({ strokeDashArray });
          this.borderStyle = style;
          this.strokeDashArray = style === 'dashed' ? strokeDashArrayParam : [];
          this.fabricRef.canvas?.renderAll();
        } catch (e) {
          console.error(e);
        }
        
        this.fabricRef.canvas?.fire("object:modified", { target: this.fabricRef });
        this.emit("MODIFIED", this.toJSON());
    }
      
    public setDashedArray(value: Array<number>) {
        this.emit("BEFORE_MODIFY", this.toJSON());
        
        try {
          this.fabricRef.set({ strokeDashArray: value });
          this.strokeDashArray = value;
          this.fabricRef.canvas?.renderAll();
        } catch (e) {
          console.error(e);
        }
        
        this.fabricRef.canvas?.fire("object:modified", { target: this.fabricRef });
        this.emit("MODIFIED", this.toJSON());
    }
      
    public setBorderThickness(thickness: number) {
        this.emit("BEFORE_MODIFY", this.toJSON());
        
        try {
          this.fabricRef.set('strokeWidth', thickness);
          this.strokeWidth = thickness;
          this.fabricRef.canvas?.renderAll();
        } catch (e) {
          console.error(e);
        }
        
        this.fabricRef.canvas?.fire("object:modified", { target: this.fabricRef });
        this.emit("MODIFIED", this.toJSON());
    }
      
    public setBorderColor(color: string) {
        this.emit("BEFORE_MODIFY", this.toJSON());
        
        try {
          this.fabricRef.set('stroke', color);
          this.stroke = color;
          this.fabricRef.canvas?.renderAll();
        } catch (e) {
          console.error(e);
        }
        
        this.fabricRef.canvas?.fire("object:modified", { target: this.fabricRef });
        this.emit("MODIFIED", this.toJSON());
    }
      
    public setBackgroundColor(color: string) {
        this.emit("BEFORE_MODIFY", this.toJSON());
        
        try {
          this.fabricRef.set('backgroundColor', color);
          this.backgroundColor = color;
          this.fabricRef.canvas?.renderAll();
        } catch (e) {
          console.error(e);
        }
        
        this.fabricRef.canvas?.fire("object:modified", { target: this.fabricRef });
        this.emit("MODIFIED", this.toJSON());
    }   

    public override async setPropertiesFromSerializedData(data: SerializedShapeLayerInfo) {
        super.setPropertiesFromSerializedData(data);

        // Set properties of SVGLayer
        this.fill = data.fill;
        this.backgroundColor = data.backgroundColor;
        this.rx = data.rx;
        this.ry = data.ry;
        this.borderStyle = data.borderStyle;
        this.strokeDashArray = data.strokeDashArray;
        this.strokeWidth = data.strokeWidth;
        this.stroke = data.stroke;
        this.shapeType = data.shapeType;
        this.fabricRef.canvas.renderAll();
    }

    public toJSON(): SerializedShapeLayerInfo {
        let serializedLayer = super.toJSON();
        let serializedFabricShapeLayer:SerializedShapeLayerInfo = {
            ...serializedLayer,
            backgroundColor: this.backgroundColor,
            fill: this.fill,
            rx: this.rx,
            ry: this.ry,
            borderStyle: this.borderStyle,
            stroke: this.stroke,
            strokeWidth: this.strokeWidth,
            strokeDashArray: this.strokeDashArray,
            shapeType: this.shapeType
        }
        return serializedFabricShapeLayer;
    }

}